export const supplyChainEndpoints = {
  // Supply Chain - Purchase Requisition
  scPurchaseRequisition: {
    getAll: (branchId: number, pageNumber: number, pageSize: number) =>
      `/api/ScPurchaseRequisition/GetAll/${branchId}/${pageNumber}/${pageSize}`,
    getById: (id: number, branchId: number) => `/api/ScPurchaseRequisition/GetById/${id}/${branchId}`,
    getRequisitionLinesByRequisitionId: (id: number, branchId: number) =>
      `/api/ScPurchaseRequisition/GetRequisitionLinesByRequisitionId/${id}/${branchId}`,
    getItems: (branchId: number) => `/api/ScPurchaseRequisition/GetItems/${branchId}`,
    save: '/api/ScPurchaseRequisition/Save',
    update: '/api/ScPurchaseRequisition/Update',
    delete: (id: number) => `/api/ScPurchaseRequisition/Delete/${id}`,
  },

  // Supply Chain - Purchase Order
  scPurchaseOrder: {
    getAll: (branchId: number, pageNumber: number, pageSize: number) =>
      `/api/ScPurchaseOrder/GetAll/${branchId}/${pageNumber}/${pageSize}`,
    getById: (id: number, branchId: number) => `/api/ScPurchaseOrder/GetById/${id}/${branchId}`,
    getLinesByOrderId: (orderId: number, branchId: number) => `/api/ScPurchaseOrder/GetLinesByOrderId/${orderId}/${branchId}`,
    getRequisitions: (branchId: number) => `/api/ScPurchaseOrder/GetRequisitions/${branchId}`,
    getRequisitionById: (requisitionId: number, branchId: number) =>
      `/api/ScPurchaseOrder/GetRequisitionById/${requisitionId}/${branchId}`,
    getTaxes: (branchId: number) => `/api/ScPurchaseOrder/GetTaxes?branchId=${branchId}`,
    getVendors: (branchId: number) => `/api/ScPurchaseOrder/GetVendors?branchId=${branchId}`,
    save: '/api/ScPurchaseOrder/Save',
    update: '/api/ScPurchaseOrder/Update',
    delete: (id: number, branchId: number) => `/api/ScPurchaseOrder/Delete/${id}/${branchId}`,
  },

  /** Supply Chain — Goods Receipt Note (ScGrn) */
  scGrn: {
    getAll: (branchId: number, pageNumber: number, pageSize: number) => `/api/ScGrn/GetAll/${branchId}/${pageNumber}/${pageSize}`,
    getById: (id: number, branchId: number) => `/api/ScGrn/GetById/${id}/${branchId}`,
    getGrnLinesByGrnId: (grnId: number, branchId: number) => `/api/ScGrn/GetGrnLinesByGrnId/${grnId}/${branchId}`,
    getVendors: (branchId: number) => `/api/ScGrn/GetVendors?branchId=${branchId}`,
    getPurchaseOrdersByVendorId: (vendorId: number, branchId: number) =>
      `/api/ScGrn/GetPurchaseOrdersByVendorId/${vendorId}/${branchId}`,
    save: '/api/ScGrn/Save',
    update: '/api/ScGrn/Update',
    convertToBillIndividually: '/api/ScGrn/ConvertToBillIndividually',
    convertToBillCombined: '/api/ScGrn/ConvertToBillCombined',
  },
} as const

